// extracted by mini-css-extract-plugin
export default {"view":"ProjectList_view__zdo1e","image":"ProjectList_image__f5ZE+","info":"ProjectList_info__JABEf","title":"ProjectList_title__BjHVk","desc":"ProjectList_desc__MHn0o"};